var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.47 28.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Uebersetzungen mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.9,
    width: 22.31,
    height: 4.62,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.52,
    width: 22.31,
    height: 4.62,
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.14,
    width: 22.31,
    height: 4.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,30H9.89V14.32H33.2ZM10.89,29H32.2V15.32H10.89Z",
    transform: "translate(-9.89 -14.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.55,
    y: 32.85,
    width: 22.31,
    height: 3.81,
    transform: "translate(47.52 55.2) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.04,
    y: 32.68,
    width: 15.34,
    height: 3.81,
    transform: "translate(53.4 -8.44) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.73,
    y: 13.25,
    width: 22.24,
    height: 14.51,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 27.6 29.93 15.47 30.04 13.1 29.27 13.1 7.73 25.53 7.82 27.35 8.93 27.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.58 14.74 28.55 27.53 29.83 27.16 29.77 25.54 8.8 12.76 7.81 13.43 7.58 14.74",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.55,
    y: 33.6,
    width: 22.31,
    height: 2.38,
    transform: "translate(47.52 55.26) rotate(180)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.37,
    y: 33.56,
    width: 14.67,
    height: 2.38,
    transform: "translate(53.56 -8.28) rotate(90)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.59,
    y: 31.24,
    width: 13.66,
    height: 0.9,
    transform: "translate(17.02 56.63) rotate(-148.63)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.13,
    y: 36.92,
    width: 13.66,
    height: 0.85,
    transform: "translate(33.62 72.58) rotate(-148.63)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.82,
    y: 37.7,
    width: 14.01,
    height: 0.8,
    transform: "matrix(-0.86, 0.5, -0.5, -0.86, 53.65, 44.78)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.13,
    y: 30.97,
    width: 13.66,
    height: 0.77,
    transform: "translate(69.18 27.12) rotate(149.88)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.36,42.58H17.05V26.91H40.36Zm-22.31-1H39.36V27.91H18.05Z",
    transform: "translate(-9.89 -14.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.55,
    y: 32.85,
    width: 9.97,
    height: 0.75,
    transform: "translate(35.18 52.13) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 32.85,
    width: 9.63,
    height: 0.75,
    transform: "translate(59.52 52.13) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.55,
    y: 35.98,
    width: 9.97,
    height: 0.75,
    transform: "translate(35.18 58.38) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 35.98,
    width: 9.63,
    height: 0.75,
    transform: "translate(59.52 58.38) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.34,
    y: 30.3,
    width: 5.85,
    height: 0.75,
    transform: "translate(51.05 -13.91) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.34,
    y: 38.53,
    width: 5.85,
    height: 0.75,
    transform: "translate(59.28 -5.69) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.22,
    y: 38.53,
    width: 5.85,
    height: 0.75,
    transform: "translate(56.16 -2.56) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.22,
    y: 30.3,
    width: 5.85,
    height: 0.75,
    transform: "translate(47.93 -10.79) rotate(90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateMobil);
export default __webpack_public_path__ + "static/media/translate-mobil.13e3a745c62b9bb8f62514a1031200cb.svg";
export { ForwardRef as ReactComponent };